/**
 * @generated SignedSource<<7fca8337d9b217e7a4fa2380f670c4a7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespMarketplaceStickyHeader_item$data = {
  readonly isOnHold: boolean | null;
  readonly isPriceUponRequest: boolean | null;
  readonly serviceId: string | null;
  readonly title: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedBuyItNowButton_item" | "PdpSharedContactSellerButton_item" | "PdpSharedMakeOfferButton_item" | "PdpSharedPurchaseButton_item" | "PriceDisplay_item">;
  readonly " $fragmentType": "PdpRespMarketplaceStickyHeader_item";
};
export type PdpRespMarketplaceStickyHeader_item$key = {
  readonly " $data"?: PdpRespMarketplaceStickyHeader_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespMarketplaceStickyHeader_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespMarketplaceStickyHeader_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOnHold",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPriceUponRequest",
      "storageKey": null
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        },
        {
          "kind": "Variable",
          "name": "priceBookName",
          "variableName": "priceBookName"
        },
        {
          "kind": "Variable",
          "name": "userCountryCode",
          "variableName": "userCountryCode"
        },
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "kind": "FragmentSpread",
      "name": "PriceDisplay_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedContactSellerButton_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedPurchaseButton_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedBuyItNowButton_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedMakeOfferButton_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "93f077f5fe1c5f06426eaa6813863a33";

export default node;
